module.exports = __webpack_public_path__ + "media/images/application/poulpe-70fe1fb78a01206b712341800eef24fc.svg";